import { ThemeModeType } from '@make-software/cspr-design';
import type React from 'react';
import { useCallback } from 'react';
import { SkeletonTheme } from 'react-loading-skeleton';
import { ThemeProvider } from 'styled-components';

import { ClickTopBar } from 'components';
import { useLocalStorage } from 'hooks';

import { AppTheme } from './appTheme';
import { GlobalStyles } from './globalStyle';

export const ThemeWrapper: React.FC<React.PropsWithChildren> = ({ children }) => {
  const [themeMode, setThemeMode] = useLocalStorage('themeMode', ThemeModeType.light);

  const toggleTheme = useCallback(() => {
    const isCurrentLightTheme = themeMode === ThemeModeType.light;

    setThemeMode(isCurrentLightTheme ? ThemeModeType.dark : ThemeModeType.light);
  }, [setThemeMode, themeMode]);

  return (
    <ThemeProvider theme={AppTheme[themeMode]}>
      <GlobalStyles />
      {/* ClickUI must stay mounted for CSPR.click sign-in to work; its
          visual bar is hidden by the beam-standalone CSS in index.css. */}
      <div aria-hidden>
        <ClickTopBar themeMode={themeMode} onThemeSwitch={toggleTheme} />
      </div>

      <SkeletonTheme
        baseColor={AppTheme[themeMode].styleguideColors.backgroundPrimary}
        highlightColor={AppTheme[themeMode].styleguideColors.fillSecondary}
        enableAnimation
      >
        {children}
      </SkeletonTheme>
    </ThemeProvider>
  );
};
